import React from 'react';
import SubMenuNavigation from '../../common/components/Navigation/SubMenuNavigation';
import { Route } from 'react-router-dom';
import * as routes from '../../utils/routes';
import * as SC from '../../common/General.styles';
import BrandUpload from './subpages/BrandUpload.container';
import BackOfficePageContainer from './subpages/BackofficeDefault.container';

const BackOfficePage = () => {
    return (
        <SC.PageMainWrapper>
            <SC.PageWrapper>
                <SubMenuNavigation
                    subRouteWithComponents={routes.BACK_OFFICE_PAGE.SUB_ROUTES}
                    themeConfig={routes.BACK_OFFICE_PAGE.config}
                />
                <div>
                    <Route
                        exact
                        path={routes.BACK_OFFICE_PAGE.SUB_ROUTES.HOME_PAGE.path}
                        component={BackOfficePageContainer}
                    />
                    <Route
                        exact
                        path={routes.BACK_OFFICE_PAGE.SUB_ROUTES.BRAND_UPLOAD_PAGE.path}
                        component={BrandUpload}
                    />
                </div>
            </SC.PageWrapper>
        </SC.PageMainWrapper>
    );
};

export default BackOfficePage;
